import {LOGOUT_REQUEST} from '@redux/modules/session/types';

import * as types from './types';

const sitesReducer = (
  state = {
    isFetching: false,
    list: [],
    locale: undefined,
    isFetchingSiteResources: false,
    siteResources: {},
    isFetchingSiteTypes: undefined,
    siteTypesDict: {},
  },
  action,
) => {
  switch (action.type) {
    case types.SITE_TYPES_REQUEST:
      return {...state, isFetching: true};

    case types.SITE_TYPES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload.list,
        locale: action.payload.locale,
      };

    case types.SITE_TYPES_FAILURE:
      return {...state, isFetching: false};

    case types.GET_SITE_RESOURCES_REQUEST:
      return {
        ...state,
        isFetchingSiteResources: true,
        siteResources: {},
      };

    case types.GET_SITE_RESOURCES_SUCCESS:
      return {
        ...state,
        isFetchingSiteResources: false,
        siteResources: action.payload.data,
      };

    case types.GET_SITE_RESOURCES_FAILURE:
      return {...state, isFetchingSitenResources: false};

    case types.SITE_TYPES_DICT_REQUEST:
      return {...state, isFetchingSiteTypes: true};

    case types.SITE_TYPES_DICT_SUCCESS:
      return {
        ...state,
        isFetchingSiteTypes: false,
        siteTypesDict: {
          ...state.siteTypesDict,
          [action.payload.clientId]: {
            [action.payload.locale]: action.payload.list,
          },
        },
      };

    case types.SITE_TYPES_DICT_FAILURE:
      return {...state, isFetchingSiteTypes: false};

    case LOGOUT_REQUEST:
      return {
        ...state,
        isFetchingSiteTypes: false,
        siteTypesDict: {},
      };

    default:
      return state;
  }
};

export default sitesReducer;
